import { useEffect, useState } from "react";

function enhanceImages(root = document) {
  const images = root.querySelectorAll ? root.querySelectorAll("img") : [];
  images.forEach((img) => {
    if (!img.hasAttribute("loading")) img.setAttribute("loading", "lazy");
    if (!img.hasAttribute("decoding")) img.setAttribute("decoding", "async");
    if (!img.hasAttribute("alt")) img.setAttribute("alt", "");
    if (img.dataset.fpbEnhanced === "true") return;
    img.dataset.fpbEnhanced = "true";
    img.addEventListener("error", () => {
      if (!img.src.includes("image-fallback.svg")) img.src = "/image-fallback.svg";
    });
  });
}

export default function PerformanceEnhancer() {
  const [online, setOnline] = useState(typeof navigator === "undefined" ? true : navigator.onLine);
  const [updateReady, setUpdateReady] = useState(false);

  useEffect(() => {
    enhanceImages(document);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) enhanceImages(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    const showUpdate = () => setUpdateReady(true);

    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    window.addEventListener("fpb:pwa-update-ready", showUpdate);

    return () => {
      observer.disconnect();
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("fpb:pwa-update-ready", showUpdate);
    };
  }, []);

  return (
    <>
      {!online && (
        <div className="fpb-network-banner" role="status">
          You are offline. Some fresh pages may not load until connection returns.
        </div>
      )}
      {updateReady && (
        <div className="fpb-update-banner" role="status">
          A new website update is available.
          <button onClick={() => window.location.reload()}>Refresh</button>
        </div>
      )}
    </>
  );
}
